import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const CaseStudyIllustration = ({ label, color, icon }) => (
  <div style={{
    width: '100%',
    height: '280px',
    background: color,
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px'
  }}>
    <div style={{ fontSize: '64px', lineHeight: 1 }}>{icon}</div>
    <div style={{
      color: 'rgba(255,255,255,0.85)',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '0.05em',
      textTransform: 'uppercase'
    }}>{label}</div>
  </div>
);

class FeaturesSplit extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-split section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-split-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
      'split-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    const sectionHeader = {
      title: 'Recent Work',
      paragraph: 'A sample of projects that showcase our capabilities across healthcare tech, integrations, and custom development.'
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content reveal-from-top" />
            <div className={splitClasses}>

              <div className="split-item">
                <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                  <div className="case-study-tag">Healthcare Technology</div>
                  <h3 className="mt-8 mb-16">
                    Insurance Broker Enrollment Platform
                  </h3>
                  <p className="m-0">
                    A health insurance brokerage needed a modern quoting and enrollment platform to replace a fragmented,
                    spreadsheet-driven process. We built a full-stack application that pulls live carrier rates, generates
                    customized proposals, and automates the enrollment workflow—reducing the average close time by over 60%.
                    The platform integrates with carrier APIs and syncs client data directly into their CRM.
                  </p>
                </div>
                <div className={
                  classNames(
                    'split-item-image center-content-mobile reveal-rotate-from-left',
                    imageFill && 'split-item-image-fill'
                  )}
                  data-reveal-container=".split-item">
                  <CaseStudyIllustration
                    icon="🏥"
                    label="Enrollment Platform"
                    color="linear-gradient(135deg, #0e7490 0%, #0f172a 100%)"
                  />
                </div>
              </div>

              <div className="split-item">
                <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                  <div className="case-study-tag">CRM Integration</div>
                  <h3 className="mt-8 mb-16">
                    HubSpot &amp; Legal CRM Integration
                  </h3>
                  <p className="m-0">
                    Our client was using Zapier to bridge their HubSpot sales pipeline with their legal CRM, but
                    UI-based automations couldn't handle the custom logic they needed. We replaced it with a robust
                    backend integration that syncs opportunities, creates and matches legal matters, and maps custom
                    attributes in real time—without any manual intervention from the team.
                  </p>
                </div>
                <div className={
                  classNames(
                    'split-item-image center-content-mobile reveal-rotate-from-right',
                    imageFill && 'split-item-image-fill'
                  )}
                  data-reveal-container=".split-item">
                  <CaseStudyIllustration
                    icon="🔗"
                    label="CRM Integration"
                    color="linear-gradient(135deg, #0284c7 0%, #0f172a 100%)"
                  />
                </div>
              </div>

              <div className="split-item">
                <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                  <div className="case-study-tag">Custom Application</div>
                  <h3 className="mt-8 mb-16">
                    Operations &amp; Admin Dashboard
                  </h3>
                  <p className="m-0">
                    A growing services company needed their first web application—one that customers could use to
                    request and track services, and that employees could use to manage day-to-day operations. We
                    built a bespoke Rails application modeled exactly on their existing workflow, digitizing
                    their operations and providing management with real-time data to make better business decisions.
                  </p>
                </div>
                <div className={
                  classNames(
                    'split-item-image center-content-mobile reveal-rotate-from-left',
                    imageFill && 'split-item-image-fill'
                  )}
                  data-reveal-container=".split-item">
                  <CaseStudyIllustration
                    icon="📊"
                    label="Operations Dashboard"
                    color="linear-gradient(135deg, #0d9488 0%, #0f172a 100%)"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
